import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../actions/actionCreators';
import * as customerActions from '../actions/customerActions';
import * as invoiceActions from '../actions/invoiceActions';
import * as stockcountActions from '../actions/stockcountActions';
import NavigationBar from './NavigationBar';
import LogBar from './LogBar';
import SingleWarehouse from './SingleWarehouse';
import WareHouseGrid from './WareHouseGrid';
import StockCountWareHouseWrapper from './StockCountWareHouseWrapper';
import Settings from './Settings';
import Dashboard from './Dashboard';
import Transactions from './Transactions';
import Reconcile from './Reconcile';
import ActivityHistory from './ActivityHistory';
import BillTransactionHistory from './BillTransactionHistory';
import {
  Routes,
  Route,
  BrowserRouter
} from "react-router-dom";
import CustomerInsights from './CustomerInsights';
import CustomerInsightsDetail from './CustomerInsightsDetail';
import CustomerProductBreakdown from './CustomerProductBreakdown';
import CustomerList from './CustomerLists';
import CustomerUnitsSold from './CustomerUnitsSold';
import CustomerMargin from './CustomerMargin';


class App extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {

    if (this.props.auth.isAuthenticated) {
      return (
        <BrowserRouter>
          <div className="header">
            <div className="NavBar" >
              <NavigationBar />
            </div>
          </div>
            <Routes>
            <Route path="/" element={<Dashboard {...this.props} />} />
            <Route path="/stock" element={<WareHouseGrid {...this.props} />} />
            <Route path="/dashboard" element={<Dashboard {...this.props} />} />
            <Route path="/customerinsights" element={<CustomerInsights {...this.props} />} />
            <Route path="/CustomerList" element={<CustomerList {...this.props} />} />

            <Route path="/activity" element={<ActivityHistory {...this.props} />} />
            <Route path="/billtransaction" element={<BillTransactionHistory {...this.props} />} />
            <Route path="/customer/:customerId" element={<CustomerInsightsDetail {...this.props} />} />
            <Route path="/customervolume/:customerId" element={<CustomerUnitsSold {...this.props} />} />
            <Route path="/customermargin/:customerId" element={<CustomerMargin {...this.props} />} />
            <Route path="/productbreakdown/:customerId" element={<CustomerProductBreakdown {...this.props} />} />
            <Route path="/customerBlob/:customerId" element={<CustomerInsightsDetail {...this.props} />} />
            <Route path="/editwh/:warehouseId" element={<StockCountWareHouseWrapper {...this.props} />} />
            <Route path="/view/:warehouseId/reconcile" element={<Reconcile {...this.props} />} />
            <Route path="/view/:warehouseId/tran" element={<Transactions {...this.props} />} />
            <Route path="/view/:warehouseId" element={<SingleWarehouse {...this.props} />} />
            <Route path="/settings" element={<Settings {...this.props} />} />
          </Routes>
          </BrowserRouter>
      )
    } else {
      return (
        <div className="maincontainer">
          <div className="header">
            <div className="NavBar" >
              <LogBar requestLogin={this.props.requestLogin} isAuthenticated={this.props.auth.isAuthenticated} errorMessage={this.props.auth.errorMessage} />
            </div>
          </div>
        </div>
      )
    }
  }
}



function mapStateToProps(state) {
  return {
    warehouses: state.warehouses,
    products: state.products,
    pricelists: state.pricelists,
    invoices: state.invoices,
    editablePricelist: state.editablePricelist,
    editableInvoice: state.editableInvoice,
    auth: state.auth,
    customers: state.customers,
    stockcount: state.stockcount,
    customersalesdata: state.customersalesdata,
    warehousedashboard: state.warehousedashboard,
    transactions: state.transactions,
    statements: state.statements,
    reconcilliation: state.reconcilliation,
    activity: state.activity,
    billtransaction: state.billtransaction

  }
}
function mapDispachToProps(dispatch) {
  return bindActionCreators({ ...actionCreators, ...customerActions, ...invoiceActions, ...stockcountActions }, dispatch);
}

export default connect(mapStateToProps, mapDispachToProps)(App)